export const SectionOurMissionTranslationsCs = {
  'Our mission': 'Naše mise',
  'First mission': 'Spočívá v tom, že změníte své vnímání svého šatníku.',
  'Second mission':
    'Uspokojte potřebu využívání a nošení drahého šatníku bez nutnosti jej kupovat, což nepochybně šetří vaše peníze a neomezuje vás v příjemných emocích.',
  'Third mission':
    'Pokračování v životním cyklu oblečení má významný pozitivní vliv na životní prostředí. Víme, že společnost začala uvažovat o více vědomých a ekologických způsobech spotřeby věcí. Proto používání existujících oděvů místo kupování nových přispívá k zlepšení ekologie planety.',
  'Unique cyclic model': "Pronájem z našeho katalogu",
  'Description first about model':
    "Vyberte si šaty nebo oblek, velikost a termín pronájmu. Dostupnost a cenu uvidíte při rezervaci.",
  'Description second about model':
    "Rezervaci můžete vytvořit i bez účtu. S přihlášeným účtem najdete své rezervace a jejich stav na jednom místě.",
};
